<template>
  <div>
    <v-row>
      <v-col md="12">
        <v-data-table
          :loading-text="table.title"
          :server-items-length="table.total"
          :loading="table.loading"
          :headers="table.headers"
          :items="table.data"
          :items-per-page="table.options.itemsPerPage"
          :footer-props="{
            'items-per-page-options': [15, 20, 30]
          }"
          :page="table.options.page"
          @update:options="updateTable"
          dense
          class="elevation-1">
          <template v-slot:item.quantity="{ item }">
            <div>
              {{ item.quantity | toFixNumber(3) | numberWithComma }}
            </div>
          </template>
          <template
            v-slot:item.name="{ item }">
            <div class="price-cell">
              <v-tooltip right>
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    {{ item.name }}
                    <v-icon v-if="item.choice === null || (item.choice && item.choice.provider === null)" color="red" small>mdi-alert</v-icon>
                    <div v-else>
                      <div class="grey--text" v-if="item.choice">
                        {{ item.product.category.name }}
                      </div>
                      <div :class="item.onModel === 'Recipe' ? 'grey--text' : 'red--text'" v-else>
                        {{ item.onModel === 'Recipe' ? 'Subrecetas' : 'Error en la variante' }}
                      </div>
                    </div>
                  </span>
                </template>
                <div v-if="item.choice === null || (item.choice && item.choice.provider === null)">
                  <span>Este ingrediente ya no está disponible, por favor elige uno nuevo</span>
                </div>
                <div v-else>
                    <div
                    v-if="item.choice"
                    style="width: 100%" >
                    ${{ item.choice.amount | toFix2 | numberWithComma }} x {{ item.choice.unit.code }}
                  </div>
                  <div
                    v-else
                    style="width: 100%">
                    ${{ (item.product || {}).unitCost || 0 | toFix2 | numberWithComma }} x {{ item.unit.code }}
                  </div>
                </div>
              </v-tooltip>
            </div>
          </template>
          <template v-slot:item.price="{ item }">
            <div class="align-center">
              ${{ item.price | toFix2 | numberWithComma }}
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import RecipeModel from '@/models/Recipe'

export default {
  props: {
    recipe: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    let recipeModel = new RecipeModel()

    return {
      recipeModel,
      table: {
        title: this.$i18n.t('ingredients.loading'),
        loading: true,
        headers: [
          { text: this.$i18n.t('ingredients.headers.name'), value: 'name' },
          { text: this.$i18n.t('ingredients.headers.quantity'), value: 'quantity' },
          { text: this.$i18n.t('ingredients.headers.baseUnit'), value: 'unit.name' },
          { text: this.$i18n.t('ingredients.headers.price'), value: 'price' }
        ],
        data: [],
        total: 0,
        options: {
          groupBy: [],
          groupDesc: [],
          itemsPerPage: 15,
          multiSort: false,
          mustSort: false,
          page: 1,
          sortBy: ['name'],
          sortDesc: [false]
        }
      },
      selectedRecipe: {
        name: '',
        cost: ''
      }
    }
  },
  computed: {
    units: function () {
      const unitsAllowed = [
        'm',
        'cm',
        'g',
        'kg',
        'oz',
        'l',
        'ml',
        'glass',
        'cup',
        'cop',
        'oza',
        'ozi',
        'teaspoon',
        'tablespoon',
        'pz',
        'unit'
      ]
      return this.$store.state.login.units.data.filter(unit => unitsAllowed.includes(unit.code)) || []
    }
  },
  watch: {
    recipe: async function (val) {
      if (val) {
        const recipe = cloneDeep(val)
        this.recipeModel = new RecipeModel(recipe)
        this.selectedRecipe = val
      }
      if (val.uuid) await this.load()
    }
  },
  methods: {
    updateTable: async function (data) {
      if (this.recipe.uuid) {
        this.table.options = data
        await this.load()
      }
    },
    load: async function (params = null) {
      params = params || {
        sort: `${this.table.options.sortDesc[0] ? '-' : ''}${this.table.options.sortBy[0]}`,
        limit: this.table.options.itemsPerPage,
        skip: (this.table.options.itemsPerPage * (this.table.options.page - 1))

      }
      this.table.loading = true
      try {
        const response = await this
          .fetch(`recipes/${this.recipe.uuid}/ingredients`, params)
        this.table.data = response.data
        this.table.total = response.total
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.table.loading = false
    },
    fetch: async function (entity, params) {
      return this.$api.get(`/v1/${entity}`, params)
    }
  }
}
</script>

<style lang="scss" scoped>
.price{
  &-cell {
    position: relative;
  }
}
</style>
